import React from 'react';
import { BookOpenIcon, ClipboardListIcon, DumbbellIcon, HomeIcon, TimerIcon, TrendingUpIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
const icons = {
  book: BookOpenIcon,
  clipboard: ClipboardListIcon,
  trend: TrendingUpIcon,
  home: HomeIcon,
  gym: DumbbellIcon,
  timer: TimerIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-41" data-mp="zdsijp9iljxb">
      <div className="mx-auto max-w-6xl" data-id="element-42" data-mp="13ecjz514f9p9">
        <SectionTitle data-id="element-43" data-mp="13f41xd1sp8x2">
          This isn't just another collection of exercises. <Mark data-id="element-44" data-mp="18cw3kys8s9eg">It's a complete, organized exercise system.</Mark>
        </SectionTitle>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-45" data-mp="1dc8sdp2obqjo">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-46" data-mp="2orp3mrvjjqav">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand/10" data-id="element-47" data-mp="2oq48b01ek3by">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-48" data-mp="bmq33du9ru2y" />
                </span>
                <div data-id="element-49" data-mp="7l4it7feodiq">
                  <h3 className="font-display text-sm font-black uppercase leading-tight text-navy" data-id="element-50" data-mp="2o5ooovqs6kj">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-steel" data-id="element-51" data-mp="3tuyp3qipo1o0">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}